import { PermissionsType } from '@/common/permissionsConst';
import PvDemonstrationBase from './index';
import { Themes } from '@maxtropy/components';

const routes = [
  {
    path: '/distributed/intelligentPv/demonstrationBase',
    permission: PermissionsType.P_PVVIEW,
    theme: Themes.DARK,
    element: <PvDemonstrationBase />,
  },
];

export default routes;
